import { useQueryState } from '@ywwwtseng/react-kit';

export function useNetwotks() {
  const networks = useQueryState<string[]>('networks');
  return networks;
}
